@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Reports"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.name }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="created_dt" title="Created Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.created_dt | dateTimezone }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column class="align-center">
    <ng-template let-report kendoGridCellTemplate [unityTyped]="T">
      <unity-button-download-shared
        buttonText="Generate Report"
        [gridIconOnly]="true"
        [disabled]="$activeDownloadIdSet().has(report.id)"
        (clickEvent)="downloadReport(report)" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
